import type { SizedIconProps } from '../BaseIcon';
import { BaseIcon } from '../BaseIcon';
import { IconSize } from '../../../../enums';

type ThumbsUpIconProps = Omit<SizedIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const ThumbsUpIcon = ({
  strokeWidth,
  size = IconSize.Standard,
  width,
  height,
  ...props
}: ThumbsUpIconProps) => {
  const isMini = size === IconSize.Mini;
  const iconWidth = width ?? (isMini ? 12 : 17);
  const iconHeight = height ?? (isMini ? 12 : 16);

  return (
    <BaseIcon
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 17 16"
      fill="none"
      strokeWidth={strokeWidth}
      {...props}
    >
      <g clipPath="url(#clip0_9004_424)">
        <path d="M5 6.5L5.10254 6.50488C5.60667 6.55621 6 6.98232 6 7.5V15C6 15.5523 5.55228 16 5 16H1C0.447715 16 0 15.5523 0 15V7.5L0.00488281 7.39746C0.0562144 6.89333 0.482323 6.5 1 6.5H5ZM2 14H4V8.5H2V14Z" />
        <path d="M9 3C9 2.67498 8.92164 2.49769 8.85547 2.39844C8.788 2.29724 8.69197 2.21767 8.56836 2.15332L6 7.71973V14H11.916C12.3799 14 12.7832 13.681 12.8896 13.2295L14.2373 7.5H10C9.44772 7.5 9 7.05228 9 6.5V3ZM11 5.5H14.2373C15.527 5.5 16.4799 6.70264 16.1846 7.95801L14.8359 13.6875C14.5169 15.0424 13.308 16 11.916 16H5C4.44772 16 4 15.5523 4 15V7.5C4 7.35537 4.03122 7.21239 4.0918 7.08105L7.0918 0.581055L7.16211 0.454102C7.34481 0.173554 7.65878 0 8 0V1C8 0.0151745 8.00048 0.000226411 8.00098 0H8.02148C8.03079 0.000150014 8.04248 0.000537657 8.05566 0.000976562C8.08211 0.00185796 8.11642 0.00392121 8.15723 0.00683594C8.23843 0.0126377 8.34787 0.0234849 8.47656 0.0449219C8.72955 0.0870872 9.08255 0.173111 9.44727 0.355469C9.8159 0.539784 10.2149 0.832077 10.5195 1.28906C10.8284 1.75231 11 2.32502 11 3V5.5Z" />
      </g>
      <defs>
        <clipPath id="clip0_9004_424">
          <rect width="16.2386" height="16" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

ThumbsUpIcon.displayName = 'ThumbsUpIcon';
